import { render } from "./IconPhoneOut.vue?vue&type=template&id=42aeb10e"
const script = {}
script.render = render

export default script